/* with love from shopstory */
var index = require('./index-0b475274.js');
var React = require('react');
var storage = require('./storage-a8e10214.js');
var throttle = require('lodash.throttle');
var slate = require('slate');
var slateReact = require('slate-react');
var styled = require('styled-components');
require('@stitches/core');
require('lodash.curry');
require('crypto-js');
require('react-dom');
require('lodash.debounce');
require('react-textarea-autosize');
require('react-beautiful-dnd');
require('tslib');
require('@react-aria/tooltip');
require('react-popper');
require('./ThumbnailButton-653e256d.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var throttle__default = /*#__PURE__*/_interopDefaultLegacy(throttle);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */

function identity(value) {
  return value;
}

var identity_1 = identity;

function serialize(value) {
  if (value instanceof Error) {
    return JSON.parse(JSON.stringify(value, Object.getOwnPropertyNames(value)));
  }

  return JSON.parse(JSON.stringify(value));
}

function isContextEditorContext(context) {
  return !!context.isEditing;
}

function responsiveValueReduce(resVal, reducer, initialValue, devices) {
  if (!index.isTrulyResponsiveValue(resVal)) {
    return reducer(initialValue, resVal);
  }

  var result = initialValue;

  for (var i = 0; i < devices.length; i++) {
    var key = devices[i].id;

    if (resVal[key] === undefined) {
      continue;
    }

    result = reducer(result, resVal[key]);
  }

  return result;
}

function responsiveValueValues(value) {
  var values = [];
  index.entries(value).forEach(function (_ref) {
    var _ref2 = index._slicedToArray(_ref, 2),
        key = _ref2[0],
        v = _ref2[1];

    if (key === "$res") return;
    values.push(v);
  });
  return values;
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct$1()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) storage._setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, storage._getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return storage._setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = storage._getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = storage._getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return storage._possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FetchResourceError = /*#__PURE__*/function (_Error) {
  storage._inherits(FetchResourceError, _Error);

  var _super = _createSuper(FetchResourceError);

  function FetchResourceError(resourceId) {
    storage._classCallCheck(this, FetchResourceError);

    return _super.call(this, "Unable to fetch the resource for id \"".concat(resourceId, "\""));
  }

  return FetchResourceError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

function _createForOfIteratorHelper$1(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { index._defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function syncResources(_x, _x2, _x3, _x4) {
  return _syncResources.apply(this, arguments);
}

function _syncResources() {
  _syncResources = index._asyncToGenerator( /*#__PURE__*/index.regenerator.mark(function _callee(config, resourcesStore, compilationContext, shopstoryClient) {
    var stagedForMap, fetchersResults;
    return index.regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            stagedForMap = collectItemsForFetch(config, resourcesStore, compilationContext);

            if (isContextEditorContext(compilationContext)) {
              savePendingResources(resourcesStore, stagedForMap);
            }

            _context.next = 4;
            return runFetchers(stagedForMap, compilationContext, shopstoryClient);

          case 4:
            fetchersResults = _context.sent;
            saveSyncedResources(resourcesStore, stagedForMap, fetchersResults);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _syncResources.apply(this, arguments);
}

function getDefaultFetcherForType(type, compilationContext) {
  var _compilationContext$r2;

  if (type === "text") {
    if (!compilationContext.text) {
      throw new Error("There is external text in config but there is no fetch function");
    }

    return compilationContext.text.defaultFetch;
  } else if (type === "image" || type === "video") {
    var _compilationContext$r;

    return (_compilationContext$r = compilationContext.resourceTypes[compilationContext[type].resourceType]) === null || _compilationContext$r === void 0 ? void 0 : _compilationContext$r.defaultFetch;
  }

  return (_compilationContext$r2 = compilationContext.resourceTypes[type]) === null || _compilationContext$r2 === void 0 ? void 0 : _compilationContext$r2.defaultFetch;
}

function getFetcherForType(type, compilationContext) {
  var _compilationContext$r4;

  if (type === "text") {
    var _compilationContext$t;

    if (!((_compilationContext$t = compilationContext.text) === null || _compilationContext$t === void 0 ? void 0 : _compilationContext$t.fetch)) {
      throw new Error("There is external text in config but there is no fetch function");
    }

    return compilationContext.text.fetch;
  } else if (type === "image" || type === "video") {
    var _compilationContext$r3;

    return (_compilationContext$r3 = compilationContext.resourceTypes[compilationContext[type].resourceType]) === null || _compilationContext$r3 === void 0 ? void 0 : _compilationContext$r3.fetch;
  }

  return (_compilationContext$r4 = compilationContext.resourceTypes[type]) === null || _compilationContext$r4 === void 0 ? void 0 : _compilationContext$r4.fetch;
}

function getTransformer(schemaProp, compilationContext) {
  var _schemaProp$transform;

  var type = schemaProp.type;

  if (type === "text") {
    return identity_1;
  }

  if (schemaProp.type === "image" || schemaProp.type === "video") {
    return compilationContext[schemaProp.type].transform;
  }

  return (_schemaProp$transform = schemaProp.transform) !== null && _schemaProp$transform !== void 0 ? _schemaProp$transform : identity_1;
}

function collectItemsForFetch(config, resourcesStore, compilationContext) {
  var stagedForMap = {};
  storage.configTraverse(config, compilationContext, function (_ref) {
    var value = _ref.value,
        schemaProp = _ref.schemaProp;

    if (!index.isResourceSchemaProp(schemaProp)) {
      return;
    }

    var pendingResources = [];

    if (index.isTrulyResponsiveValue(value)) {
      responsiveValueValues(value).forEach(function (currentValue) {
        if (!currentValue) {
          return;
        }

        pendingResources.push(currentValue);
      });
    } else {
      pendingResources.push(value);
    }

    var resourceFetchParams = index.getResourceFetchParams(schemaProp, compilationContext);
    pendingResources.forEach(function (resource) {
      var type = index.getResourceType(schemaProp, compilationContext);

      if (!isSyncRequired(resource, type, resourceFetchParams, resourcesStore)) {
        return;
      }

      if (!stagedForMap[type]) {
        stagedForMap[type] = [];
      }

      if (isResourceAlreadyStaged(stagedForMap[type], resource, resourceFetchParams, schemaProp.transformHash)) {
        return;
      }

      stagedForMap[type].push({
        schemaProp: schemaProp,
        resource: {
          id: resource.id,
          type: type,
          info: resource.info,
          fetchParams: resourceFetchParams
        }
      });
    });
  });
  return stagedForMap;
}

function isSyncRequired(resourceValue, type, params, resourcesStore) {
  if (resourceValue.id === null || index.isLocalTextResource(resourceValue, type)) {
    return false;
  }

  var resource = resourcesStore.get(index.getResourceIdentifier(resourceValue.id, resourceValue.info, params), type);
  return !resource || resource.status === "loading";
}

var BULLET_CHAR = String.fromCharCode(8226);

function runFetchers(_x5, _x6, _x7) {
  return _runFetchers.apply(this, arguments);
}

function _runFetchers() {
  _runFetchers = index._asyncToGenerator( /*#__PURE__*/index.regenerator.mark(function _callee3(stagedForMap, compilationContext, shopstoryClient) {
    var _compilationContext$s;

    var isStrictMode, shouldContinueOnFetchError, fetchResourcesResults, promises, _loop3, type, _ret;

    return index.regenerator.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            isStrictMode = (_compilationContext$s = compilationContext.strict) !== null && _compilationContext$s !== void 0 ? _compilationContext$s : true; // By default, fetching during editing doesn't throw up whole app because that would be bad, but we throw when user
            // is fetching resources outside of editor ex. during their build of app.
            // This behavior is good, but there are cases where user wouldn't want it.
            // User can disable default behavior by setting `strict: false` in Shopstory config

            shouldContinueOnFetchError = isContextEditorContext(compilationContext) || !isStrictMode;
            fetchResourcesResults = [];
            promises = [];

            _loop3 = function _loop3(type) {
              var stagedResources = stagedForMap[type];
              var fetcherInputs = removeDuplicated(stagedResources).map(buildResourceInput);
              var defaultFetcher = getDefaultFetcherForType(type, compilationContext);
              var customFetcher = getFetcherForType(type, compilationContext);
              var fetcher = customFetcher !== null && customFetcher !== void 0 ? customFetcher : defaultFetcher;

              if (!fetcher) {
                var missingFetcherErrorMessage = "Missing fetch function for type \"".concat(type, "\". If this is custom resource type, make sure to provide fetch method for it within Shopstory config.");

                if (shouldContinueOnFetchError) {
                  console.error(missingFetcherErrorMessage);
                  return "continue";
                }

                throw new Error(missingFetcherErrorMessage);
              }

              var fetcherParams = _objectSpread$5(_objectSpread$5({}, compilationContext.contextParams), {}, {
                isEditing: !!compilationContext.isEditing,
                shopstoryClient: shopstoryClient
              });

              var fetchResources = fetcher(fetcherInputs, fetcherParams);
              promises.push(new Promise(function (resolve, reject) {
                fetchResources.then( /*#__PURE__*/function () {
                  var _ref3 = index._asyncToGenerator( /*#__PURE__*/index.regenerator.mark(function _callee2(fetchResourcesResult) {
                    var _compilationContext$r5;

                    var nonArrayResultErrorMessage, invalidFetchResultsErrorMessage, combinedResourcesResult, remainingUnresolvedResources, defaultFetchResourcesResult, unresolvedResources, unresolvedResourcesErrorMessage, defaultFetchErrorMessage, resolvedResourcesResults, typePostFetch, postFetchErrorMessage, unresolvedResourcesParagraph, _unresolvedResourcesErrorMessage, currentTypeFetchResourcesResults, transformResolvedResources;

                    return index.regenerator.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            transformResolvedResources = function _transformResolvedRes(stagedResources, results) {
                              var ret = [];

                              var _iterator = _createForOfIteratorHelper$1(stagedResources),
                                  _step;

                              try {
                                var _loop4 = function _loop4() {
                                  var stagedResource = _step.value;
                                  var stagedResourceResult = results.find(function (result) {
                                    return index.resourceByIdentity(result.id, result.type, result.info, result.fetchParams)(stagedResource.resource);
                                  });

                                  if (!stagedResourceResult) {
                                    return "continue";
                                  }

                                  var transformedResult = void 0;

                                  try {
                                    var transformer = getTransformer(stagedResource.schemaProp, compilationContext);

                                    if (stagedResourceResult.value) {
                                      transformedResult = transformer(stagedResourceResult.value, fetcherParams);
                                    }
                                  } catch (error) {
                                    console.error(error);
                                    var typeTransformErrorMessage = "Transformer for type \"".concat(type, "\" and id \"").concat(stagedResourceResult.id, "\" finished with error. This is not Shopstory error.");

                                    if (shouldContinueOnFetchError) {
                                      console.error(typeTransformErrorMessage);
                                      resolve(null);
                                    } else {
                                      reject(new Error(typeTransformErrorMessage));
                                    }
                                  }
                                  /**
                                   * Here we're checking whether mappedResult is serializable. Right now with JSON.stringify.
                                   */


                                  try {
                                    JSON.stringify(transformedResult);
                                    ret.push(_objectSpread$5(_objectSpread$5({}, stagedResourceResult), {}, {
                                      value: transformedResult,
                                      transformHash: stagedResource.schemaProp.transformHash
                                    }));
                                  } catch (error) {
                                    var circularReferencesErrorMessage = "Resource of type \"".concat(type, "\" and id \"").concat(stagedResourceResult.id, "\" resolved to object with circular references. This is not Shopstory error.");

                                    if (shouldContinueOnFetchError) {
                                      console.error(circularReferencesErrorMessage);
                                    } else {
                                      reject(new Error(circularReferencesErrorMessage));
                                    }
                                  }
                                };

                                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                                  var _ret2 = _loop4();

                                  if (_ret2 === "continue") continue;
                                }
                              } catch (err) {
                                _iterator.e(err);
                              } finally {
                                _iterator.f();
                              }

                              return ret;
                            };

                            if (!(customFetcher && !defaultFetcher)) {
                              _context2.next = 10;
                              break;
                            }

                            if (Array.isArray(fetchResourcesResult)) {
                              _context2.next = 6;
                              break;
                            }

                            nonArrayResultErrorMessage = "Result of fetch function for type \"".concat(type, "\" is not an array, got \"").concat(JSON.stringify(fetchResourcesResult), "\" instead. Make sure to return an array of resources from your custom fetch.");

                            if (shouldContinueOnFetchError) {
                              console.error(nonArrayResultErrorMessage);
                              resolve(null);
                            } else {
                              reject(new Error(nonArrayResultErrorMessage));
                            }

                            return _context2.abrupt("return");

                          case 6:
                            if (validateFetchResults(fetchResourcesResult)) {
                              _context2.next = 10;
                              break;
                            }

                            invalidFetchResultsErrorMessage = "Results of fetch function for type \"".concat(type, "\" are invalid. Each result should be one of:\n").concat(BULLET_CHAR, " undefined\n").concat(BULLET_CHAR, " same as resource input\n").concat(BULLET_CHAR, " resolved resource with \"value\" or \"error\" property.");

                            if (shouldContinueOnFetchError) {
                              console.error(invalidFetchResultsErrorMessage);
                              resolve(null);
                            } else {
                              reject(new Error(invalidFetchResultsErrorMessage));
                            }

                            return _context2.abrupt("return");

                          case 10:
                            combinedResourcesResult = index._toConsumableArray(fetchResourcesResult);
                            remainingUnresolvedResources = getUnresolvedResources(fetcherInputs, combinedResourcesResult);

                            if (!(customFetcher && defaultFetcher && remainingUnresolvedResources.length > 0)) {
                              _context2.next = 31;
                              break;
                            }

                            _context2.prev = 13;
                            _context2.next = 16;
                            return defaultFetcher(remainingUnresolvedResources, fetcherParams);

                          case 16:
                            defaultFetchResourcesResult = _context2.sent;
                            combinedResourcesResult = [].concat(index._toConsumableArray(defaultFetchResourcesResult), index._toConsumableArray(fetchResourcesResult.filter(isResourceResolved)));
                            unresolvedResources = getUnresolvedResources(fetcherInputs, combinedResourcesResult);

                            if (!(unresolvedResources.length > 0)) {
                              _context2.next = 23;
                              break;
                            }

                            unresolvedResourcesErrorMessage = "Default fetch for type \"".concat(type, "\" didn't resolve remaining unresolved resources returned from custom fetch. This is probably Shopstory error.\n\nBelow is the list of unresolved resources:\n").concat(JSON.stringify(unresolvedResources, null, 2));

                            if (shouldContinueOnFetchError) {
                              console.error(unresolvedResourcesErrorMessage);
                              resolve(null);
                            } else {
                              reject(new Error(unresolvedResourcesErrorMessage));
                            }

                            return _context2.abrupt("return");

                          case 23:
                            _context2.next = 31;
                            break;

                          case 25:
                            _context2.prev = 25;
                            _context2.t0 = _context2["catch"](13);
                            console.error(_context2.t0);
                            defaultFetchErrorMessage = "Above error occurred in default fetch function for type \"".concat(type, "\". This is probably Shopstory error.");

                            if (shouldContinueOnFetchError) {
                              console.error(defaultFetchErrorMessage);
                              resolve(null);
                            } else {
                              reject(new Error(defaultFetchErrorMessage));
                            }

                            return _context2.abrupt("return");

                          case 31:
                            resolvedResourcesResults = combinedResourcesResult.filter(function (result) {
                              return result !== undefined && isResourceResolved(result);
                            });
                            typePostFetch = (_compilationContext$r5 = compilationContext.resourceTypes[type]) === null || _compilationContext$r5 === void 0 ? void 0 : _compilationContext$r5.postFetch;

                            if (!typePostFetch) {
                              _context2.next = 46;
                              break;
                            }

                            _context2.prev = 34;
                            _context2.next = 37;
                            return typePostFetch(resolvedResourcesResults, fetcherParams);

                          case 37:
                            resolvedResourcesResults = _context2.sent;
                            _context2.next = 46;
                            break;

                          case 40:
                            _context2.prev = 40;
                            _context2.t1 = _context2["catch"](34);
                            console.error(_context2.t1);
                            postFetchErrorMessage = "postFetch function for resource of type \"".concat(type, "\" finished with error above. This is not Shopstory error.\n\nBelow is the input for which the method failed:\n").concat(JSON.stringify(resolvedResourcesResults, null, 2));

                            if (shouldContinueOnFetchError) {
                              console.error(postFetchErrorMessage);
                              resolve(null);
                            } else {
                              reject(new Error(postFetchErrorMessage));
                            }

                            return _context2.abrupt("return");

                          case 46:
                            remainingUnresolvedResources = getUnresolvedResources(fetcherInputs, resolvedResourcesResults);

                            if (remainingUnresolvedResources.length > 0) {
                              unresolvedResourcesParagraph = "Below is the list of remaining unresolved resources:\n".concat(JSON.stringify(remainingUnresolvedResources, null, 2));
                              _unresolvedResourcesErrorMessage = "Fetching resources for type \"".concat(type, "\" didn't resolve all resources. This is not Shopstory error.\n\n").concat(unresolvedResourcesParagraph, "\n\n");

                              if (shouldContinueOnFetchError) {
                                console.error(_unresolvedResourcesErrorMessage);
                              } else {
                                reject(new Error(_unresolvedResourcesErrorMessage));
                              }
                            }

                            currentTypeFetchResourcesResults = transformResolvedResources(stagedResources, resolvedResourcesResults);
                            fetchResourcesResults.push.apply(fetchResourcesResults, index._toConsumableArray(currentTypeFetchResourcesResults));
                            resolve(null);

                          case 51:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, null, [[13, 25], [34, 40]]);
                  }));

                  return function (_x8) {
                    return _ref3.apply(this, arguments);
                  };
                }())["catch"](function (error) {
                  console.error(error);
                  var fetchErrorMessage = "Fetch function for type \"".concat(type, "\" finished with error above. This is not Shopstory error.\n\nBelow is the input for which the resource fetch failed:\n").concat(JSON.stringify(fetcherInputs, null, 2));

                  if (shouldContinueOnFetchError) {
                    console.error(fetchErrorMessage);
                    resolve(null);
                  } else {
                    reject(new Error(fetchErrorMessage));
                  }
                });
              }));
            };

            _context3.t0 = index.regenerator.keys(stagedForMap);

          case 6:
            if ((_context3.t1 = _context3.t0()).done) {
              _context3.next = 13;
              break;
            }

            type = _context3.t1.value;
            _ret = _loop3(type);

            if (!(_ret === "continue")) {
              _context3.next = 11;
              break;
            }

            return _context3.abrupt("continue", 6);

          case 11:
            _context3.next = 6;
            break;

          case 13:
            _context3.next = 15;
            return Promise.all(promises);

          case 15:
            return _context3.abrupt("return", fetchResourcesResults);

          case 16:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _runFetchers.apply(this, arguments);
}

function isAnyPendingResource(config, resourcesStore, compilationContext) {
  var isDirty = false;
  storage.configTraverse(config, compilationContext, function (_ref2) {
    var value = _ref2.value,
        schemaProp = _ref2.schemaProp;

    if (!index.isResourceSchemaProp(schemaProp)) {
      return;
    }

    var type = index.getResourceType(schemaProp, compilationContext);
    var params = index.getResourceFetchParams(schemaProp, compilationContext);
    var isResourcePendingAtAnyDevice = responsiveValueReduce(value, function (isPreviousPending, unresolvedResource) {
      return isPreviousPending || index.isPendingResource(resourcesStore, unresolvedResource, type, params);
    }, false, compilationContext.devices);

    if (isResourcePendingAtAnyDevice) {
      isDirty = true;
    }
  });
  return isDirty;
}

function saveSyncedResources(resourcesStore, stagedResourcesMap, syncedResources) {
  resourcesStore.batch(function () {
    var _loop = function _loop(resourceType) {
      var stagedResources = stagedResourcesMap[resourceType];
      var syncedResourcesOfType = syncedResources.filter(function (resource) {
        return resource.type === resourceType;
      }); // We MUST iterate over all staged resources because some resources could be missing from synced resources
      // if ex. some fetch function has thrown ending up with no resource result.
      // Maybe we should improve the way we handle those kind of errors and actually put the rejected resource into synced resources.

      stagedResources.forEach(function (stagedResource) {
        var stagedResourceIdentifier = index.getResourceIdentifier(stagedResource.resource.id, stagedResource.resource.info, stagedResource.resource.fetchParams);
        var relatedSyncedResource = syncedResourcesOfType.find(function (syncedResource) {
          var syncedResourceIdentifier = index.getResourceIdentifier(syncedResource.id, syncedResource.info, syncedResource.fetchParams);
          return stagedResourceIdentifier === syncedResourceIdentifier && syncedResource.transformHash === stagedResource.schemaProp.transformHash;
        });

        if (!relatedSyncedResource) {
          resourcesStore.set(stagedResourceIdentifier, {
            id: stagedResource.resource.id,
            status: "error",
            error: new FetchResourceError(stagedResource.resource.id),
            type: resourceType,
            values: undefined,
            info: stagedResource.resource.info,
            fetchParams: stagedResource.resource.fetchParams
          });
          return;
        }

        if (relatedSyncedResource.value) {
          var _relatedSyncedResourc;

          var transformHash = (_relatedSyncedResourc = relatedSyncedResource.transformHash) !== null && _relatedSyncedResourc !== void 0 ? _relatedSyncedResourc : "default";
          var storedResource = resourcesStore.get(stagedResourceIdentifier, resourceType);

          if (storedResource) {
            if (storedResource.status == "success" || storedResource.status == "loading") {
              var newValues = Object.assign({}, storedResource.status === "success" ? storedResource.values : {}, index._defineProperty({}, transformHash, relatedSyncedResource.value));

              var updatedStoredResource = _objectSpread$5(_objectSpread$5({}, storedResource), {}, {
                status: "success",
                values: newValues
              });

              resourcesStore.set(stagedResourceIdentifier, updatedStoredResource);
            }
          } else {
            resourcesStore.set(stagedResourceIdentifier, {
              id: relatedSyncedResource.id,
              status: "success",
              error: null,
              type: relatedSyncedResource.type,
              values: index._defineProperty({}, transformHash, relatedSyncedResource.value),
              info: relatedSyncedResource.info,
              fetchParams: relatedSyncedResource.fetchParams
            });
          }
        } else {
          var resourceError = relatedSyncedResource.error ? relatedSyncedResource.error : new FetchResourceError(relatedSyncedResource.id);
          resourcesStore.set(stagedResourceIdentifier, {
            id: stagedResource.resource.id,
            status: "error",
            error: resourceError,
            type: resourceType,
            values: undefined,
            info: stagedResource.resource.info,
            fetchParams: stagedResource.resource.fetchParams
          });
        }
      });
    };

    for (var resourceType in stagedResourcesMap) {
      _loop(resourceType);
    }
  });
}

function savePendingResources(resourcesStore, stagedForMap) {
  resourcesStore.batch(function () {
    var _loop2 = function _loop2(type) {
      var stagedInstances = stagedForMap[type];
      stagedInstances.forEach(function (stagedInstance) {
        var resourceId = index.getResourceIdentifier(stagedInstance.resource.id, stagedInstance.resource.info, stagedInstance.resource.fetchParams);
        resourcesStore.set(resourceId, {
          id: stagedInstance.resource.id,
          status: "loading",
          type: type,
          error: null,
          values: undefined,
          fetchParams: stagedInstance.resource.fetchParams
        });
      });
    };

    for (var type in stagedForMap) {
      _loop2(type);
    }
  });
}

function getUnresolvedResources(resourcesToFetch, fetchedResources) {
  var unresolvedResources = [];
  resourcesToFetch.forEach(function (resource) {
    var resourceResult = fetchedResources.find(function (result) {
      return result !== undefined && index.getResourceIdentifier(result.id, result.info, result.fetchParams) === index.getResourceIdentifier(resource.id, resource.info, resource.fetchParams);
    });

    if (!resourceResult) {
      unresolvedResources.push(resource);
      return;
    }

    if (!isResourceResolved(resourceResult)) {
      unresolvedResources.push(resource);
    }
  });
  return unresolvedResources;
}

function isResourceResolved(fetchResourceResult) {
  return fetchResourceResult !== undefined && ("value" in fetchResourceResult || "error" in fetchResourceResult);
}

function isResourceAlreadyStaged(stagedResources, resource, fetchParams, transformKey) {
  return stagedResources.some(function (staged) {
    return index.getResourceIdentifier(staged.resource.id, staged.resource.info, staged.resource.fetchParams) === index.getResourceIdentifier(resource.id, resource.info, fetchParams) && transformKey === staged.schemaProp.transformHash;
  });
}

function validateFetchResults(results) {
  return results.every(function (result) {
    return typeof result === "object" && result !== null || result === undefined;
  });
}

function removeDuplicated(resources) {
  var uniqueResources = [];
  resources.forEach(function (resource) {
    var isDuplicate = uniqueResources.some(function (uniqueResource) {
      var currentUniqueStagedResourceIdentifier = index.getResourceIdentifier(uniqueResource.resource.id, uniqueResource.resource.info, uniqueResource.resource.fetchParams);
      var resourceIdentifier = index.getResourceIdentifier(resource.resource.id, resource.resource.info, resource.resource.fetchParams);
      return currentUniqueStagedResourceIdentifier === resourceIdentifier;
    });

    if (!isDuplicate) {
      uniqueResources.push(resource);
    }
  });
  return uniqueResources;
}

function buildResourceInput(stagedResource) {
  var resourceInput = {
    id: stagedResource.resource.id,
    type: stagedResource.resource.type
  };

  if (stagedResource.resource.info) {
    resourceInput.info = stagedResource.resource.info;
  }

  if (stagedResource.resource.fetchParams) {
    resourceInput.fetchParams = stagedResource.resource.fetchParams;
  }

  return resourceInput;
}

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { index._defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var InternalShopstoryClient = /*#__PURE__*/function () {
  function InternalShopstoryClient(compilationContext, resourcesStore, apiStorage) {
    storage._classCallCheck(this, InternalShopstoryClient);

    index._defineProperty(this, "compiledConfigsReferences", void 0);

    index._defineProperty(this, "pendingContent", void 0);

    index._defineProperty(this, "compilationContext", void 0);

    index._defineProperty(this, "resourcesStore", void 0);

    index._defineProperty(this, "apiStorage", void 0);

    this.resourcesStore = resourcesStore;
    this.compilationContext = compilationContext;
    this.apiStorage = apiStorage;
    this.compiledConfigsReferences = [];
    this.pendingContent = [];
  }

  storage._createClass(InternalShopstoryClient, [{
    key: "add",
    value: function add(input) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        mode: "content"
      };

      if (!storage.isComponentConfig(input) && !storage.dist.isContentPiece(input) && !storage.dist.isRawContent(input) && input !== null && input !== undefined) {
        var error = "ShopstoryClient has received an invalid input.";
        console.error("".concat(error, " Got "), input);
        throw new Error(error);
      }

      var result = {
        renderableContent: null
      };
      this.compiledConfigsReferences.push(result);
      var normalizedRawContent = this.normalizeInputIntoRawContent(input, options.mode);
      this.pendingContent.push({
        value: normalizedRawContent,
        mode: options.mode,
        resultReference: result
      });
      return result;
    }
  }, {
    key: "build",
    value: function () {
      var _build = index._asyncToGenerator( /*#__PURE__*/index.regenerator.mark(function _callee() {
        var _this = this;

        var meta, syncedContentPieces, configs, _iterator, _step, pendingContentPiece, _config, zoneConfig, resultMeta, _loop, _i, _syncedContentPieces, resources;

        return index.regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.pendingContent.length === 0)) {
                  _context.next = 3;
                  break;
                }

                meta = {
                  definitions: {
                    actions: [],
                    components: [],
                    links: [],
                    textModifiers: []
                  },
                  devices: this.compilationContext.devices,
                  resources: [],
                  image: this.compilationContext.image,
                  video: this.compilationContext.video
                };
                return _context.abrupt("return", serialize(meta));

              case 3:
                syncedContentPieces = [];

              case 4:
                if (!(this.pendingContent.length > 0)) {
                  _context.next = 34;
                  break;
                }

                configs = [];
                _iterator = _createForOfIteratorHelper(this.pendingContent);
                _context.prev = 7;

                _iterator.s();

              case 9:
                if ((_step = _iterator.n()).done) {
                  _context.next = 20;
                  break;
                }

                pendingContentPiece = _step.value;
                _context.next = 13;
                return this.getConfigFromRawContent(pendingContentPiece.value);

              case 13:
                _config = _context.sent;

                if (_config) {
                  _context.next = 16;
                  break;
                }

                throw new Error("Missing component config within Content Piece");

              case 16:
                configs.push(_config);
                syncedContentPieces.push({
                  value: _config,
                  mode: pendingContentPiece.mode,
                  resultReference: pendingContentPiece.resultReference
                });

              case 18:
                _context.next = 9;
                break;

              case 20:
                _context.next = 25;
                break;

              case 22:
                _context.prev = 22;
                _context.t0 = _context["catch"](7);

                _iterator.e(_context.t0);

              case 25:
                _context.prev = 25;

                _iterator.f();

                return _context.finish(25);

              case 28:
                this.pendingContent.length = 0;
                zoneConfig = {
                  _template: "$Zone",
                  blocks: configs
                };
                _context.next = 32;
                return syncResources(zoneConfig, this.resourcesStore, this.compilationContext, this);

              case 32:
                _context.next = 4;
                break;

              case 34:
                resultMeta = undefined;

                _loop = function _loop() {
                  var _syncedContentPieces$ = _syncedContentPieces[_i],
                      value = _syncedContentPieces$.value,
                      resultReference = _syncedContentPieces$.resultReference;

                  var _compile = storage.compile(value, _this.compilationContext),
                      compiled = _compile.compiled,
                      meta = _compile.meta;

                  var currentCompiledConfigIndex = _this.compiledConfigsReferences.findIndex(function (compiledConfigReference) {
                    return compiledConfigReference === resultReference;
                  });

                  _this.compiledConfigsReferences[currentCompiledConfigIndex].renderableContent = serialize(compiled);
                  resultMeta = !resultMeta ? meta : mergeCompilationMeta(resultMeta, meta);
                };

                for (_i = 0, _syncedContentPieces = syncedContentPieces; _i < _syncedContentPieces.length; _i++) {
                  _loop();
                }

                resources = this.resourcesStore.values().map(function (resource) {
                  if (resource.status === "error" && resource.error) {
                    return serialize(_objectSpread$4(_objectSpread$4({}, resource), {}, {
                      error: serialize(resource.error)
                    }));
                  }

                  return serialize(resource);
                });
                return _context.abrupt("return", _objectSpread$4(_objectSpread$4({}, serialize(resultMeta)), {}, {
                  resources: resources
                }));

              case 39:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 22, 25, 28]]);
      }));

      function build() {
        return _build.apply(this, arguments);
      }

      return build;
    }()
  }, {
    key: "getConfigFromRawContent",
    value: function () {
      var _getConfigFromRawContent = index._asyncToGenerator( /*#__PURE__*/index.regenerator.mark(function _callee2(input) {
        var configResponse;
        return index.regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(storage.dist.isRawContentLocal(input) || storage.dist.isRawContentFull(input))) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return", input.content);

              case 4:
                _context2.next = 6;
                return this.apiStorage.getConfigForLocale({
                  id: input.id
                }, this.compilationContext.contextParams.locale);

              case 6:
                configResponse = _context2.sent;

                if (configResponse) {
                  _context2.next = 9;
                  break;
                }

                throw new Error("ShopstoryClient was unable to fetch content piece with id \"".concat(input.id, "\""));

              case 9:
                return _context2.abrupt("return", storage.normalize(configResponse.config, this.compilationContext));

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getConfigFromRawContent(_x) {
        return _getConfigFromRawContent.apply(this, arguments);
      }

      return getConfigFromRawContent;
    }()
  }, {
    key: "normalizeInputIntoRawContent",
    value: function normalizeInputIntoRawContent(input, mode) {
      if (!input) {
        return {
          content: storage.normalize(input !== null && input !== void 0 ? input : storage.getDefaultConfig(mode), this.compilationContext)
        };
      }

      var rawContent = storage.convertInputConfigIntoRawContent(input);

      if (storage.dist.isRawContentRemote(rawContent)) {
        return rawContent;
      }

      return _objectSpread$4(_objectSpread$4({}, rawContent), {}, {
        content: storage.normalize(rawContent.content, this.compilationContext)
      });
    }
  }]);

  return InternalShopstoryClient;
}();

function mergeCompilationMeta(meta1, meta2) {
  return _objectSpread$4(_objectSpread$4({}, meta1), {}, {
    definitions: {
      actions: mergeDefinitions(meta1.definitions.actions, meta2.definitions.actions),
      components: mergeDefinitions(meta1.definitions.components, meta2.definitions.components),
      textModifiers: mergeDefinitions(meta1.definitions.textModifiers, meta2.definitions.textModifiers),
      links: mergeDefinitions(meta1.definitions.links, meta2.definitions.links)
    }
  });
}

function mergeDefinitions(definitions1, definitions2) {
  var mergeDefinitions = index._toConsumableArray(definitions1);

  definitions2.forEach(function (definition) {
    var isDuplicate = definitions1.some(function (d) {
      return d.id === definition.id;
    });

    if (isDuplicate) {
      return;
    }

    mergeDefinitions.push(definition);
  });
  return mergeDefinitions;
}

React__default["default"].createElement;
function $image(props) {
  var __fromEditor = props.__fromEditor;
  var _fromEditor$props = __fromEditor.props,
      image = _fromEditor$props.image,
      aspectRatio = _fromEditor$props.aspectRatio,
      gridBaseLineHeight = _fromEditor$props.gridBaseLineHeight;
  var _fromEditor$componen = __fromEditor.components,
      Wrapper = _fromEditor$componen.Wrapper,
      AspectRatioMaker = _fromEditor$componen.AspectRatioMaker,
      ImageWrapper = _fromEditor$componen.ImageWrapper;

  var _useRuntimeContext = index.useRuntimeContext(),
      devices = _useRuntimeContext.devices,
      Image = _useRuntimeContext.Image,
      stitches = _useRuntimeContext.stitches;

  var aspectRatioClassName = index.getAspectRatioClassName(image, aspectRatio, gridBaseLineHeight, devices, stitches);
  var imageWrapperClassName = index.getWrapperClassName(image, devices, stitches);
  return index.createElement(Wrapper, null, index.createElement(AspectRatioMaker, {
    className: aspectRatioClassName
  }), index.createElement(ImageWrapper, {
    className: imageWrapperClassName
  }, index.responsiveValueToSelectivelyDisplayedComponents(image, function (image) {
    return index.createElement(index.ImageRenderer, {
      image: image,
      Image: Image
    });
  }, devices, stitches)));
}

React__default["default"].createElement;
var $video = function $video(props) {
  var __fromEditor = props.__fromEditor;
  var _fromEditor$componen = __fromEditor.components,
      Wrapper = _fromEditor$componen.Wrapper,
      AspectRatioMaker = _fromEditor$componen.AspectRatioMaker,
      ImageWrapper = _fromEditor$componen.ImageWrapper;
  var _fromEditor$props = __fromEditor.props,
      image = _fromEditor$props.image,
      aspectRatio = _fromEditor$props.aspectRatio,
      gridBaseLineHeight = _fromEditor$props.gridBaseLineHeight;

  var _useRuntimeContext = index.useRuntimeContext(),
      devices = _useRuntimeContext.devices,
      stitches = _useRuntimeContext.stitches;

  var _useState = React.useState(false),
      isMounted = _useState[0],
      setMounted = _useState[1];

  var _useForceRerender = index.useForceRerender(),
      forceRerender = _useForceRerender.forceRerender;

  React.useEffect(function () {
    setMounted(true);
  }, []);
  React.useEffect(function () {
    var onResize = function onResize() {
      forceRerender();
    };

    window.addEventListener("resize", onResize);
    return function () {
      window.removeEventListener("resize", onResize);
    };
  });
  var aspectRatioClassName = index.getAspectRatioClassName(image, aspectRatio, gridBaseLineHeight, devices, stitches);
  var imageWrapperClassName = index.getWrapperClassName(image, devices, stitches);
  return index.createElement(Wrapper, null, index.createElement(AspectRatioMaker, {
    className: aspectRatioClassName
  }), index.createElement(ImageWrapper, {
    className: imageWrapperClassName
  }, index.responsiveValueToSelectivelyDisplayedComponents(image, function (video) {
    return index.createElement(index.VideoRenderer, index._extends({}, props, {
      video: video
    }));
  }, devices, stitches, isMounted)));
};

var RICH_TEXT_CONFIG_SYNC_THROTTLE_TIMEOUT = 150;
var RICH_TEXT_FOCUSED_FIELDS_SYNC_THROTTLE_TIMEOUT = 100;

function convertRichTextElementsToEditorValue(richTextElements) {
  if (!richTextElements || richTextElements.length === 0) {
    return getPlaceholderRichTextElements();
  }

  return richTextElements.map(function (richTextBlockElementComponentConfig) {
    return convertRichTextBlockElementComponentConfigToEditorElement(richTextBlockElementComponentConfig);
  });
}

function convertRichTextPartComponentConfigToEditorText(richTextPartComponentConfig) {
  return {
    color: richTextPartComponentConfig.color,
    font: richTextPartComponentConfig.font,
    id: richTextPartComponentConfig._id,
    text: richTextPartComponentConfig.value
  };
}

function convertRichTextBlockElementComponentConfigToEditorElement(blockElementComponentConfig) {
  if (blockElementComponentConfig.type === "bulleted-list" || blockElementComponentConfig.type === "numbered-list") {
    return {
      id: blockElementComponentConfig._id,
      type: blockElementComponentConfig.type,
      children: blockElementComponentConfig.elements.map(function (lineElementComponentConfig) {
        return {
          type: "list-item",
          id: lineElementComponentConfig._id,
          children: lineElementComponentConfig.elements.map(function (childComponentConfig) {
            if (childComponentConfig._template === storage.richTextInlineWrapperElementEditableComponent.id) {
              return {
                id: childComponentConfig._id,
                type: "inline-wrapper",
                children: childComponentConfig.elements.map(function (textPartComponentConfig) {
                  return convertRichTextPartComponentConfigToEditorText(textPartComponentConfig);
                }),
                action: childComponentConfig.action,
                actionTextModifier: childComponentConfig.actionTextModifier,
                textModifier: childComponentConfig.textModifier
              };
            }

            return convertRichTextPartComponentConfigToEditorText(childComponentConfig);
          })
        };
      })
    };
  }

  return {
    id: blockElementComponentConfig._id,
    type: blockElementComponentConfig.type,
    children: blockElementComponentConfig.elements.map(function (lineElementComponentConfig) {
      return {
        type: "text-line",
        id: lineElementComponentConfig._id,
        children: lineElementComponentConfig.elements.map(function (childComponentConfig) {
          if (childComponentConfig._template === storage.richTextInlineWrapperElementEditableComponent.id) {
            return {
              id: childComponentConfig._id,
              type: "inline-wrapper",
              children: childComponentConfig.elements.map(function (textPartComponentConfig) {
                return convertRichTextPartComponentConfigToEditorText(textPartComponentConfig);
              }),
              action: childComponentConfig.action,
              actionTextModifier: childComponentConfig.actionTextModifier,
              textModifier: childComponentConfig.textModifier
            };
          }

          return convertRichTextPartComponentConfigToEditorText(childComponentConfig);
        })
      };
    })
  };
}

function getPlaceholderRichTextElements() {
  return [{
    id: index.uniqueId(),
    type: "paragraph",
    children: [{
      id: index.uniqueId(),
      type: "text-line",
      children: [{
        id: index.uniqueId(),
        color: {
          ref: "black",
          value: "black"
        },
        font: {
          ref: "$body",
          value: ""
        },
        text: ""
      }]
    }]
  }];
}

function traverseCompiledRichTextComponentConfig(config, callback) {
  config.components.elements.forEach(function (reactElement) {
    callback(reactElement.props.compiled);
    reactElement.props.compiled.components.elements.forEach(function (compiledLineElement) {
      callback(compiledLineElement);
      compiledLineElement.components.elements.forEach(function (compiledTextPart) {
        callback(compiledTextPart);
      });
    });
  });
}

function extractElementsFromCompiledComponents(compiledRichText) {
  var extractedCompiledElementComponents = [];
  traverseCompiledRichTextComponentConfig(compiledRichText, function (compiledConfig) {
    if (compiledConfig._template === storage.richTextBlockElementEditableComponent.id || compiledConfig._template === storage.richTextLineElementEditableComponent.id || compiledConfig._template === storage.richTextInlineWrapperElementEditableComponent.id) {
      extractedCompiledElementComponents.push(compiledConfig);
    }
  });
  return extractedCompiledElementComponents;
}

function extractTextPartsFromCompiledComponents(compiledRichText) {
  var extractedTextPartComponents = [];
  traverseCompiledRichTextComponentConfig(compiledRichText, function (compiledConfig) {
    if (compiledConfig._template === storage.richTextPartEditableComponent.id) {
      extractedTextPartComponents.push(compiledConfig);
    }

    if (compiledConfig._template === storage.richTextInlineWrapperElementEditableComponent.id) {
      compiledConfig.components.elements.forEach(function (compiledTextPart) {
        extractedTextPartComponents.push(compiledTextPart);
      });
    }
  });
  return extractedTextPartComponents;
}

function parseFocusedRichTextPartConfigPath(focusedRichTextPartConfigPath) {
  var focusedRichTextPartConfigPathMatch = focusedRichTextPartConfigPath.match(/\d+(\.elements\.\d+){2,3}/);

  if (focusedRichTextPartConfigPathMatch === null) {
    throw new Error("Invalid $richTextPart config path");
  }

  var _focusedRichTextPartC = index._slicedToArray(focusedRichTextPartConfigPathMatch, 1),
      richTextPartConfigPath = _focusedRichTextPartC[0];

  var path = richTextPartConfigPath.split(".elements.").map(function (index) {
    return +index;
  });
  var rangeMatch = focusedRichTextPartConfigPath.match(/\.\{(\d+),(\d+)\}$/);
  var range = rangeMatch !== null ? [+rangeMatch[1], +rangeMatch[2]] : null;
  return {
    path: path,
    range: range
  };
}

function getEditorSelectionFromFocusedFields(focusedFields, form) {
  try {
    var anchorFocusedField = focusedFields[0];
    var focusFocusedField = storage.last(focusedFields);
    var parsedAnchorField = parseFocusedRichTextPartConfigPath(anchorFocusedField);
    var parsedFocusedField = parseFocusedRichTextPartConfigPath(focusFocusedField);

    if (!parsedAnchorField.path.length || !parsedFocusedField.path.length) {
      return null;
    }

    return {
      anchor: {
        offset: parsedAnchorField.range ? parsedAnchorField.range[0] : 0,
        path: parsedAnchorField.path
      },
      focus: {
        offset: parsedFocusedField.range ? parsedFocusedField.range[1] : storage.dotNotationGet(form.values, focusFocusedField).value.length,
        path: parsedFocusedField.path
      }
    };
  } catch (_unused) {
    return null;
  }
}

function getFocusedFieldsFromSlateSelection(editor, richTextComponentConfigPath, locale) {
  if (editor.selection === null) {
    return undefined;
  }

  var focusedRichTextPartPaths = storage.getFocusedRichTextPartsConfigPaths(editor);
  var focusedFields = focusedRichTextPartPaths.map(function (richTextPartPath) {
    return storage.getAbsoluteRichTextPartPath(richTextPartPath, richTextComponentConfigPath, locale);
  });
  return focusedFields;
}

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { index._defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function getRichTextComponentConfigFragment(sourceRichTextComponentConfig, editorContext) {
  var focussedField = editorContext.focussedField,
      form = editorContext.form,
      contextParams = editorContext.contextParams;

  var newRichTextComponentConfig = _objectSpread$3(_objectSpread$3({}, sourceRichTextComponentConfig), {}, {
    elements: index._defineProperty({}, contextParams.locale, [])
  });

  focussedField.forEach(function (focusedField) {
    var textPartConfig = storage.dotNotationGet(form.values, storage.stripRichTextPartSelection(focusedField));

    var _parseFocusedRichText = parseFocusedRichTextPartConfigPath(focusedField),
        path = _parseFocusedRichText.path,
        range = _parseFocusedRichText.range;

    var newTextPartConfig = storage.duplicateConfig(textPartConfig, editorContext);

    if (range) {
      var _textPartConfig$value;

      newTextPartConfig.value = (_textPartConfig$value = textPartConfig.value).slice.apply(_textPartConfig$value, index._toConsumableArray(range));
    }

    var lastParentConfigPath = "elements.".concat(contextParams.locale);
    path.slice(0, -1).forEach(function (pathIndex, index) {
      var currentConfigPath = lastParentConfigPath;

      if (index === 0) {
        currentConfigPath += ".".concat(pathIndex);
      } else {
        var parentConfig = storage.dotNotationGet(newRichTextComponentConfig, lastParentConfigPath);
        currentConfigPath += ".elements.".concat(Math.min(parentConfig.elements.length, pathIndex));
      }

      var currentConfig = storage.dotNotationGet(newRichTextComponentConfig, currentConfigPath);

      if (!currentConfig) {
        var sourceConfigPath = lastParentConfigPath + (index === 0 ? ".".concat(pathIndex) : ".elements.".concat(pathIndex));
        var sourceConfig = storage.dotNotationGet(sourceRichTextComponentConfig, sourceConfigPath);

        var configCopy = _objectSpread$3(_objectSpread$3({}, sourceConfig), {}, {
          elements: []
        });

        storage.dotNotationSet(newRichTextComponentConfig, currentConfigPath, configCopy);
      }

      lastParentConfigPath = currentConfigPath;
    });
    var textPartParentConfig = storage.dotNotationGet(newRichTextComponentConfig, lastParentConfigPath);
    storage.dotNotationSet(newRichTextComponentConfig, lastParentConfigPath, _objectSpread$3(_objectSpread$3({}, textPartParentConfig), {}, {
      elements: [].concat(index._toConsumableArray(textPartParentConfig.elements), [newTextPartConfig])
    }));
  });
  return newRichTextComponentConfig;
}

var __jsx$3 = React__default["default"].createElement;

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { index._defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function RichText(props) {
  var editorContext = index.useEditorContext();
  var actions = editorContext.actions,
      contextParams = editorContext.contextParams,
      form = editorContext.form,
      focussedField = editorContext.focussedField,
      locales = editorContext.locales,
      setActiveEditor = editorContext.setActiveEditor,
      setFocussedField = editorContext.setFocussedField;
  var path = props.__fromEditor.path;
  var richTextConfig = storage.dotNotationGet(form.values, path);

  var _useState = React.useState(function () {
    return storage.withShopstory(slateReact.withReact(slate.createEditor()));
  }),
      editor = _useState[0];

  var localizedRichTextElements = richTextConfig.elements[contextParams.locale];
  var fallbackRichTextElements = storage.getFallbackForLocale(richTextConfig.elements, contextParams.locale, locales);
  var richTextElements = localizedRichTextElements !== null && localizedRichTextElements !== void 0 ? localizedRichTextElements : fallbackRichTextElements;
  var richTextElementsConfigPath = "".concat(path, ".elements.").concat(contextParams.locale);

  var _useState2 = React.useState(function () {
    return convertRichTextElementsToEditorValue(richTextElements);
  }),
      editorValue = _useState2[0],
      setEditorValue = _useState2[1]; // If rich text has no value, we initialize it with default config by updating it during first render
  // This is only possible when we open entry for non main locale without fallback, this is total edge case


  if (richTextElements.length === 0 && !fallbackRichTextElements) {
    // We only want to show rich text for default config within this component, we don't want to update raw content
    // To prevent implicit update of raw content we make a deep copy.
    richTextConfig = index.deepClone(richTextConfig);
    richTextConfig.elements[contextParams.locale] = storage.convertEditorValueToRichTextElements(editorValue);
  }
  /**
   * Controls the visibility of decoration imitating browser selection of
   * the selected text after the user has blurred the content editable element.
   */


  var _useState3 = React.useState(false),
      isDecorationActive = _useState3[0],
      setIsDecorationActive = _useState3[1];
  /**
   * Keeps track what caused last change to editor value.
   * This is used in two cases:
   * - text-only changes of editable content shouldn't trigger update of `editor.children` ("text-input")
   * - changes from outside of editable content shouldn't trigger writing to editor's history within change callback ("external")
   */


  var lastChangeReason = React.useRef("text-input");
  var previousRichTextComponentConfig = React.useRef();
  var isConfigChanged = !isConfigEqual(previousRichTextComponentConfig.current, richTextConfig);

  if (previousRichTextComponentConfig.current && isConfigChanged) {
    if (lastChangeReason.current !== "paste") {
      lastChangeReason.current = "external";
    }

    previousRichTextComponentConfig.current = richTextConfig;
    var nextEditorValue = convertRichTextElementsToEditorValue(richTextElements); // React bails out the render if state setter function is invoked within render.
    // Doing it makes Slate always up-to date with the latest config if it's changed from outside.
    // https://reactjs.org/docs/hooks-faq.html#how-do-i-implement-getderivedstatefromprops

    setEditorValue(nextEditorValue);
    editor.children = nextEditorValue;
    var editorSelection = getEditorSelectionFromFocusedFields(focussedField, form); // Slate gives us two methods to update its selection:
    // - `setSelection` updates current selection, so `editor.selection` must be not null
    // - `select` sets the selection, so `editor.selection` must be null

    if (editorSelection !== null && editor.selection !== null) {
      slate.Transforms.setSelection(editor, editorSelection);
    } else if (editorSelection !== null && editor.selection === null) {
      slate.Transforms.select(editor, editorSelection);
    } else {
      slate.Transforms.deselect(editor);
    }
  }

  React.useEffect(function () {
    // We set previous value of rich text only once, then we manually assign it when needed.
    previousRichTextComponentConfig.current = richTextConfig;
  }, []);
  React.useEffect( // Component is blurred when the user selects other component in editor. This is different from blurring content editable.
  // Content editable can be blurred, but the component can remain active ex. we select some text within content editable
  // and want to update its color from the sidebar.
  function handleRichTextBlur() {
    if (!editor.selection) {
      return;
    }

    var isRichTextActive = focussedField.some(function (focusedField) {
      return focusedField.startsWith(path);
    });

    if (!isRichTextActive) {
      slate.Transforms.deselect(editor);
      setActiveEditor(null);
      var isSlateValueEmpty = isEditorValueEmpty(editor.children); // When value for current locale is empty we want to show value from fallback value instead of placeholder
      // if the fallback value is present.

      if (isSlateValueEmpty && fallbackRichTextElements !== undefined) {
        var nextRichTextElement = index.deepClone(richTextConfig);
        delete nextRichTextElement.elements[contextParams.locale];
        editor.children = convertRichTextElementsToEditorValue(fallbackRichTextElements);
        form.change(path, nextRichTextElement);
      }
    }
  }, [focussedField]);
  React.useEffect(function () {
    // If editor has been refocused and it was blurred earlier we have to disable the decoration to show only browser selection
    if (slateReact.ReactEditor.isFocused(editor) && isDecorationActive) {
      setIsDecorationActive(false);
    }
  });

  var decorate = function decorate(_ref) {
    var _ref2 = index._slicedToArray(_ref, 2),
        node = _ref2[0],
        path = _ref2[1];

    var decorations = [];

    if (slate.Text.isText(node) && isDecorationActive && editor.selection !== null) {
      var intersection = slate.Range.intersection(editor.selection, slate.Editor.range(editor, path));

      if (intersection !== null) {
        var range = _objectSpread$2({
          isHighlighted: true,
          highlightType: "text"
        }, intersection);

        decorations.push(range);
      }
    }

    if (storage.isElementInlineWrapperElement(node) && node.action.length > 0 && editor.selection !== null && slate.Range.isCollapsed(editor.selection)) {
      var _intersection = slate.Range.intersection(editor.selection, slate.Editor.range(editor, path));

      if (_intersection !== null) {
        var _range = _objectSpread$2({
          isHighlighted: true,
          highlightType: "wrapper"
        }, slate.Editor.range(editor, path));

        decorations.push(_range);
      }
    }

    return decorations;
  };

  var Elements = extractElementsFromCompiledComponents(props.__fromEditor);

  function renderElement(_ref3) {
    var attributes = _ref3.attributes,
        children = _ref3.children,
        element = _ref3.element;
    var Element = Elements.find(function (Element) {
      return Element._id === element.id || storage.NORMALIZED_IDS_TO_IDS.get(element.id) === Element._id;
    });

    if (!Element) {
      // This can only happen if the current locale has no value and has no fallback
      if (Elements.length === 0) {
        if (element.type === "list-item") {
          return __jsx$3("div", attributes, __jsx$3("div", null, children));
        }

        return __jsx$3("div", attributes, children);
      }

      throw new Error("Missing element");
    }

    var compiledStyles = function () {
      if (Element._template === storage.richTextBlockElementEditableComponent.id) {
        if (Element.props.type === "bulleted-list") {
          return Element.styled.BulletedList;
        } else if (Element.props.type === "numbered-list") {
          return Element.styled.NumberedList;
        } else if (Element.props.type === "paragraph") {
          return Element.styled.Paragraph;
        }
      } else if (Element._template === storage.richTextLineElementEditableComponent.id) {
        if (element.type === "text-line") {
          return Element.styled.TextLine;
        } else if (element.type === "list-item") {
          return Element.styled.ListItem;
        }
      } else if (Element._template === storage.richTextInlineWrapperElementEditableComponent.id) {
        return Element.styled.Link;
      }
    }();

    if (compiledStyles === undefined) {
      throw new Error("Unknown element type");
    }

    var ElementComponent = __jsx$3(index.Box, {
      __compiled: compiledStyles
    });

    return /*#__PURE__*/React.cloneElement(ElementComponent, _objectSpread$2(_objectSpread$2({}, attributes), "production" === "development" ), element.type === "list-item" ? __jsx$3("div", null, children) : children);
  }

  var TextParts = extractTextPartsFromCompiledComponents(props.__fromEditor);

  function renderLeaf(_ref4) {
    var attributes = _ref4.attributes,
        children = _ref4.children,
        leaf = _ref4.leaf;
    var TextPart = TextParts.find(function (TextPart) {
      return TextPart._id === leaf.id || storage.NORMALIZED_IDS_TO_IDS.get(leaf.id) === TextPart._id;
    });

    if (!TextPart) {
      // This can only happen if the current locale has no value and has no fallback
      if (TextParts.length === 0) {
        return __jsx$3("span", attributes, children);
      }

      throw new Error("Missing part");
    }

    var TextPartComponent = __jsx$3(index.Box, {
      __compiled: TextPart.styled.Text
    });

    var style = {
      // Fixes bug in Chrome and Edge (Chromium based) where user cannot place selection on text node
      // if the inline element is at the end of line.
      // https://github.com/ianstormtaylor/slate/issues/4704#issuecomment-1006696364
      paddingRight: "0.001em"
    };

    if (leaf.isHighlighted) {
      style.backgroundColor = leaf.highlightType === "text" ? "#B4D5FE" : "#ffff56";
    }

    return /*#__PURE__*/React.cloneElement(TextPartComponent, _objectSpread$2(_objectSpread$2({}, attributes), {}, {
      style: style
    }, "production" === "development" ), children);
  } // Setting `display: flex` for element's aligning on `Editable` component makes default styles
  // of placeholder insufficient thus they require to explicitly set `top` and `left`.


  function renderPlaceholder(_ref5) {
    var attributes = _ref5.attributes,
        children = _ref5.children;
    return __jsx$3("span", index._extends({}, attributes, {
      style: _objectSpread$2(_objectSpread$2({}, attributes.style), {}, {
        top: 0,
        left: 0
      })
    }), children);
  }

  var scheduleConfigSync = React.useCallback(throttle__default["default"](function (nextValue) {
    setEditorValue(nextValue);
    var nextElements = storage.convertEditorValueToRichTextElements(nextValue);
    actions.runChange(function () {
      var newRichTextElement = _objectSpread$2(_objectSpread$2({}, richTextConfig), {}, {
        elements: _objectSpread$2(_objectSpread$2({}, richTextConfig.elements), {}, index._defineProperty({}, editorContext.contextParams.locale, nextElements))
      });

      form.change(path, newRichTextElement);
      previousRichTextComponentConfig.current = newRichTextElement;

      if (editor.selection) {
        var nextFocusedFields = getFocusedFieldsFromSlateSelection(editor, path, contextParams.locale);
        return nextFocusedFields;
      }
    });
  }, RICH_TEXT_CONFIG_SYNC_THROTTLE_TIMEOUT), [isConfigChanged, editorContext.contextParams.locale]);
  var scheduleFocusedFieldsChange = React.useCallback( // Slate internally throttles the invocation of DOMSelectionChange for performance reasons.
  // We also throttle update of our focused fields state for the same reason.
  // This gives us a good balance between perf and showing updated fields within the sidebar.
  throttle__default["default"](function (focusedFields) {
    setFocussedField(focusedFields);
  }, RICH_TEXT_FOCUSED_FIELDS_SYNC_THROTTLE_TIMEOUT), [setFocussedField]);

  function handleEditableChange(value) {
    // Editor's value can be changed from outside ex. sidebar or history undo/redo. If the last reason for change
    // was "external", we skip this change. In case we would like to start typing immediately after undo/redo we
    // set last change reason to `text-input`.
    if (lastChangeReason.current === "external" || lastChangeReason.current === "paste") {
      lastChangeReason.current = "text-input";
      return;
    }

    var isValueSame = index.deepCompare(value, editorValue); // Slate runs `onChange` callback on any change, even when the text haven't changed.
    // If value haven't changed, it must be a selection change.

    if (isValueSame) {
      var nextFocusedFields = getFocusedFieldsFromSlateSelection(editor, path, contextParams.locale);
      scheduleFocusedFieldsChange(nextFocusedFields !== null && nextFocusedFields !== void 0 ? nextFocusedFields : []);
      return;
    }

    lastChangeReason.current = "text-input";
    scheduleConfigSync(value);
  }

  function handleEditableFocus() {
    lastChangeReason.current = "text-input"; // When value for current locale is empty we present the value from fallback.
    // If user focuses editable element, we present the value of fallback unless it's also empty.

    if (!localizedRichTextElements) {
      var nextSlateValue = editor.children;
      var nextRichTextComponentConfig;

      if (fallbackRichTextElements) {
        nextRichTextComponentConfig = richTextConfig;
        var fallbackFirstTextPart = fallbackRichTextElements[0].elements[0].elements[0]; // Keep only one line element with single empty rich text

        nextRichTextComponentConfig.elements[contextParams.locale] = [_objectSpread$2(_objectSpread$2({}, fallbackRichTextElements[0]), {}, {
          elements: [_objectSpread$2(_objectSpread$2({}, fallbackRichTextElements[0].elements[0]), {}, {
            elements: [_objectSpread$2(_objectSpread$2({}, fallbackFirstTextPart), {}, {
              value: ""
            })]
          })]
        })];
        nextSlateValue = convertRichTextElementsToEditorValue(nextRichTextComponentConfig.elements[contextParams.locale]);
        editor.children = nextSlateValue;
        slate.Transforms.select(editor, {
          anchor: slate.Editor.start(editor, []),
          focus: slate.Editor.start(editor, [])
        });
        form.change(path, nextRichTextComponentConfig);
      } else {
        // If current and fallback value is missing we have:
        // - empty Slate value
        // - empty config within component-collection-localised
        // We will build next $richText component config based on current Slate value
        nextRichTextComponentConfig = richTextConfig;
        nextRichTextComponentConfig.elements[contextParams.locale] = storage.convertEditorValueToRichTextElements(editor.children);
        form.change(path, storage.normalize(nextRichTextComponentConfig, editorContext));
      }

      previousRichTextComponentConfig.current = nextRichTextComponentConfig;

      if (editor.selection) {
        var nextFocusedFields = storage.getFocusedRichTextPartsConfigPaths(editor).map(function (richTextPartPath) {
          return storage.getAbsoluteRichTextPartPath(richTextPartPath, path, contextParams.locale);
        });
        setFocussedField(nextFocusedFields);
      }
    }
  }

  function handleEditableBlur() {
    lastChangeReason.current = "external";

    if (editor.selection) {
      editorContext.setActiveEditor(editor);
    }

    setIsDecorationActive(true);
  } // When copying content from content editable, Slate will copy HTML content of selected nodes
  // and this is not what we want. Instead we set clipboard data to contain selected content
  // in form of rich text editable component config.


  function handleEditableCopy(event) {
    var selectedRichTextComponentConfig = getRichTextComponentConfigFragment(richTextConfig, editorContext);
    event.clipboardData.setData(storage.DATA_TRANSFER_FORMAT, JSON.stringify(selectedRichTextComponentConfig));
  }

  function handleEditablePaste(event) {
    var selectedRichTextComponentConfigClipboardData = event.clipboardData.getData(storage.DATA_TRANSFER_FORMAT);

    if (selectedRichTextComponentConfigClipboardData) {
      var selectedRichTextComponentConfig = JSON.parse(selectedRichTextComponentConfigClipboardData); // Preventing the default action will also prevent Slate from handling this event on his own.

      event.preventDefault();
      var nextSlateValue = convertRichTextElementsToEditorValue(storage.duplicateConfig(selectedRichTextComponentConfig, editorContext).elements[contextParams.locale]);
      var temporaryEditor = storage.createTemporaryEditor(editor);
      slate.Editor.insertFragment(temporaryEditor, nextSlateValue);
      var nextElements = storage.convertEditorValueToRichTextElements(temporaryEditor.children);
      actions.runChange(function () {
        form.change(richTextElementsConfigPath, nextElements);
        var nextFocusedFields = getFocusedFieldsFromSlateSelection(temporaryEditor, path, contextParams.locale);
        return nextFocusedFields;
      });
      lastChangeReason.current = "paste";
    }
  }

  return __jsx$3(slateReact.Slate, {
    editor: editor,
    value: editorValue,
    onChange: handleEditableChange
  }, __jsx$3("div", null, __jsx$3(StyledEditable, {
    isBrowserSelectionHidden: isDecorationActive,
    isFallbackValueShown: !localizedRichTextElements && !!fallbackRichTextElements,
    align: props.__fromEditor.props.align,
    editorContext: editorContext,
    placeholder: "Here goes text content",
    decorate: decorate,
    renderElement: renderElement,
    renderLeaf: renderLeaf,
    renderPlaceholder: renderPlaceholder,
    onFocus: handleEditableFocus,
    onBlur: handleEditableBlur,
    onCopy: handleEditableCopy,
    onPaste: handleEditablePaste
  })));
}

function isEditorValueEmpty(editorValue) {
  return editorValue.length === 1 && editorValue[0].children.length === 1 && editorValue[0].children[0].children.length === 1 && slate.Text.isText(editorValue[0].children[0].children[0]) && editorValue[0].children[0].children[0].text === "";
}

function isConfigEqual(newConfig, oldConfig) {
  return index.deepCompare(newConfig, oldConfig);
}

var PROPS_EXCLUDED_FROM_FORWARDING = ["isBrowserSelectionHidden", "isFallbackValueShown", "align", "editorContext"]; // When we make a selection of text within editable container and then blur
// sometimes the browser selection changes and shows incorrectly selected chunks.

var StyledEditable = styled__default["default"](slateReact.Editable).withConfig({
  shouldForwardProp: function shouldForwardProp(prop, defaultValidator) {
    return !PROPS_EXCLUDED_FROM_FORWARDING.includes(prop) || defaultValidator(prop);
  },
  displayName: "richTexteditor__StyledEditable",
  componentId: "sc-1e1nyky-0"
})(function (_ref6) {
  var align = _ref6.align,
      editorContext = _ref6.editorContext,
      isBrowserSelectionHidden = _ref6.isBrowserSelectionHidden,
      isFallbackValueShown = _ref6.isFallbackValueShown;
  return _objectSpread$2(_objectSpread$2(_objectSpread$2(_objectSpread$2({
    display: "flex"
  }, mapResponsiveAlignmentToStyles(align, editorContext)), {}, {
    "& *::selection": {
      backgroundColor: "#b4d5fe"
    }
  }, isBrowserSelectionHidden && {
    "& *::selection": {
      backgroundColor: "transparent"
    }
  }), isFallbackValueShown && {
    opacity: 0.5
  }), {}, {
    // Remove any text decoration from slate nodes that are elements. We only need text decoration on text elements.
    "[data-slate-node]": {
      textDecoration: "none"
    }
  });
});

function mapResponsiveAlignmentToStyles(align, editorContext) {
  var responsiveStyles = index.resop2({
    align: index.responsiveValueFill(align, editorContext.devices, index.getDevicesWidths(editorContext.devices))
  }, function (values) {
    return {
      justifyContent: storage.mapAlignmentToFlexAlignment(values.align),
      textAlign: values.align
    };
  }, editorContext.devices);
  var compiledStyles = index.compileBox(responsiveStyles, editorContext.devices);
  return index.getBoxStyles(compiledStyles, editorContext.devices, true);
}

function selectionFramePositionChanged(target, container) {
  return {
    type: "@shopstory-editor/selection-frame-position-changed",
    payload: {
      target: target,
      container: container
    }
  };
}

var __jsx$2 = React__default["default"].createElement;

function SelectionFrameController(_ref) {
  var isActive = _ref.isActive,
      isChildrenSelectionDisabled = _ref.isChildrenSelectionDisabled,
      children = _ref.children,
      onSelect = _ref.onSelect;

  var _useState = React.useState(null),
      node = _useState[0],
      setNode = _useState[1];

  useUpdateFramePosition({
    node: node,
    isDisabled: !isActive
  });
  return __jsx$2(_StyledDiv, {
    ref: setNode,
    onClick: onSelect,
    $_css: isChildrenSelectionDisabled && styled.css(["& *{pointer-events:none !important;user-select:none !important;}"]),
    $_css2: isActive ? 1 : 0,
    $_css3: isActive ? 1 : 0.5
  }, children);
}

function useUpdateFramePosition(_ref2) {
  var node = _ref2.node,
      isDisabled = _ref2.isDisabled;
  var dispatch = storage.useEventDispatcher();
  React.useLayoutEffect(function () {
    if (isDisabled || !node) {
      return;
    }

    var updateSelectionFramePosition = createThrottledHandler(function () {
      var nodeRect = node.getBoundingClientRect();
      dispatch(selectionFramePositionChanged(nodeRect, window.document.documentElement.getBoundingClientRect()));
    });
    window.addEventListener("scroll", updateSelectionFramePosition, {
      passive: true
    });
    var handleResize = createThrottledHandler(function () {
      var nodeRect = node.getBoundingClientRect();
      dispatch(selectionFramePositionChanged(nodeRect));
    });
    window.addEventListener("resize", handleResize, {
      passive: true
    });
    var updateSelectionFramePositionInScrollableContainer = createThrottledHandler(function (event) {
      var nodeRect = node.getBoundingClientRect();
      var containerRect = event.target.getBoundingClientRect();
      dispatch(selectionFramePositionChanged(nodeRect, containerRect));
    });
    var closestScrollableElement = node.closest("[data-shopstory-scrollable-root]");
    closestScrollableElement === null || closestScrollableElement === void 0 ? void 0 : closestScrollableElement.addEventListener("scroll", updateSelectionFramePositionInScrollableContainer, {
      passive: true
    });
    dispatch(selectionFramePositionChanged(node.getBoundingClientRect(), closestScrollableElement === null || closestScrollableElement === void 0 ? void 0 : closestScrollableElement.getBoundingClientRect()));
    return function () {
      window.removeEventListener("scroll", updateSelectionFramePosition);
      window.removeEventListener("resize", handleResize);
      closestScrollableElement === null || closestScrollableElement === void 0 ? void 0 : closestScrollableElement.removeEventListener("scroll", updateSelectionFramePositionInScrollableContainer);
    };
  });
}
/**
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/scroll_event#scroll_event_throttling
 */


function createThrottledHandler(callback) {
  var isTicking = false;
  return function (event) {
    if (isTicking) {
      return;
    }

    requestAnimationFrame(function () {
      callback(event);
      isTicking = false;
    });
    isTicking = true;
  };
}

var _StyledDiv = styled__default["default"]("div").withConfig({
  displayName: "SelectionFrameController___StyledDiv",
  componentId: "sc-j5a79d-0"
})(["position:relative;display:grid;", " &:after{content:\"\";box-sizing:border-box;display:block;position:absolute;left:0;top:0;width:100%;height:100%;border:1px solid var(--tina-color-primary);opacity:", ";pointer-events:none;user-select:none;transition:all 100ms;box-shadow:var(--tina-shadow-big);z-index:var(--tina-z-index-2);}&:hover{&:after{opacity:", ";}}"], function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
}, function (p) {
  return p.$_css3;
});

var __jsx$1 = React__namespace.createElement;
function BlocksControls(_ref) {
  var children = _ref.children,
      path = _ref.path,
      disabled = _ref.disabled;

  var _useEditorContext = index.useEditorContext(),
      focussedField = _useEditorContext.focussedField,
      setFocussedField = _useEditorContext.setFocussedField;

  if (disabled) {
    return __jsx$1(React__namespace.Fragment, null, children);
  }

  var isActive = focussedField.map(function (focusedField) {
    // If the focused field is rich text part path, we want to show the frame around rich text parent component.
    if (storage.isConfigPathRichTextPart(focusedField)) {
      return focusedField.replace(storage.RICH_TEXT_PART_CONFIG_PATH_REGEXP, "");
    }

    return focusedField;
  }).includes(path);
  var childIsActive = focussedField.some(function (focusedField) {
    return focusedField.startsWith(path);
  });

  var focusOnBlock = function focusOnBlock(event) {
    var _document$activeEleme;

    event.stopPropagation();
    event.preventDefault();
    var closestEditableElementFromTarget = event.target.closest('[contenteditable="true"]');
    var isActiveElementContentEditable = ((_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.getAttribute("contenteditable")) === "true"; // If target of event is within a content editable element we don't want to focus block.
    // If active element is a content editable element, we also don't want to focus block.
    // The latter is helpful when we start text selection within the content editable element
    // and end selection outside of anchor element.

    if (closestEditableElementFromTarget || isActiveElementContentEditable) {
      return;
    }

    var isMultipleSelection = event.shiftKey;

    function getNextFocusedField() {
      if (isMultipleSelection) {
        if (focussedField.includes(path)) {
          var result = focussedField.filter(function (fieldName) {
            return fieldName !== path;
          });

          if (result.length > 0) {
            return result;
          }

          return [];
        }

        return [].concat(index._toConsumableArray(focussedField), [path]);
      }

      return path;
    }

    var nextFocusedField = getNextFocusedField();
    setFocussedField(nextFocusedField);

    if (isMultipleSelection) {
      var _document$getSelectio;

      (_document$getSelectio = document.getSelection()) === null || _document$getSelectio === void 0 ? void 0 : _document$getSelectio.removeAllRanges();
    }
  };

  return __jsx$1(SelectionFrameController, {
    isActive: isActive,
    isChildrenSelectionDisabled: !isActive && !childIsActive,
    onSelect: focusOnBlock
  }, children);
}

React__default["default"].createElement;
var EditableComponentBuilder = function EditableComponentBuilder(props) {
  var _compiled$__editing;

  var path = props.path,
      compiled = props.compiled,
      passedProps = props.passedProps;

  var _useRuntimeContext = index.useRuntimeContext(),
      ComponentBuilder = _useRuntimeContext.builders.ComponentBuilder;

  return index.createElement(BlocksControls, {
    path: path,
    disabled: (_compiled$__editing = compiled.__editing) === null || _compiled$__editing === void 0 ? void 0 : _compiled$__editing.noInline
  }, index.createElement(ComponentBuilder, {
    compiled: compiled,
    path: path,
    passedProps: passedProps
  }));
};

function RichTextEmptyComponent() {
  throw new Error("This component is empty on purpose in editor mode. $richText uses only its compiled styles.");
}

React__default["default"].createElement;

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { index._defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var PlaceholderRoot = styled__default["default"].div.withConfig({
  displayName: "Placeholder__PlaceholderRoot",
  componentId: "sc-sgmf89-0"
})(["border:1px dashed ", ";position:relative;width:", ";height:auto;transition:all 0.1s;&:hover{background-color:", ";}"], index.SSColors.blue50, function (props) {
  return props.autoWidth ? "auto" : props.width + "px";
}, index.SSColors.blue10);

function Placeholder(props) {
  var styles = {};

  if (props.width) {
    var aspectRatio = props.height / props.width;
    styles.paddingBottom = "".concat(aspectRatio * 100, "%");
  } else {
    styles.height = "".concat(props.height, "px");
  }

  var content = index.createElement("div", {
    style: _objectSpread$1({
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      display: "flex",
      color: index.SSColors.blue50,
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer"
    }, index.SSFonts.body),
    onClick: function onClick() {
      props.onClick();
    }
  }, index.createElement(index.SSIcons.Add, null), "\xA0\xA0", props.label);
  return index.createElement(PlaceholderRoot, props, index.createElement("div", {
    style: _objectSpread$1({
      position: "relative",
      width: "100%"
    }, styles)
  }), content);
}

function TypePlaceholder(props) {
  var type = props.type;
  var placeholderWidth = undefined;
  var placeholderHeight;
  var placeholderLabel;
  var autoWidth = true;

  if (type === "section") {
    placeholderWidth = 1920;
    placeholderHeight = 600;
    placeholderLabel = "Add section";
  } else if (type === "card") {
    placeholderWidth = 420;
    placeholderHeight = 600;
    placeholderLabel = "Add card";
  } else if (type === "button") {
    placeholderWidth = 250;
    placeholderHeight = 50;
    placeholderLabel = "Add button";
    autoWidth = false;
  } else if (type === "item") {
    // placeholderWidth = 250;
    placeholderHeight = 50;
    placeholderLabel = "Add item";
  } else if (type === "image") {
    placeholderWidth = 250;
    placeholderHeight = 250;
    placeholderLabel = "Add image / video / solid color";
  } else if (type === "icon") {
    placeholderWidth = 50;
    placeholderHeight = 50;
    placeholderLabel = "Pick icon";
  } else {
    throw new Error("error, bad type: '" + type + "'");
  }

  return index.createElement(Placeholder, {
    width: placeholderWidth,
    height: placeholderHeight,
    autoWidth: autoWidth,
    label: placeholderLabel,
    onClick: props.onClick
  });
}

var builders = {
  ComponentBuilder: index.ComponentBuilder,
  EditableComponentBuilder: EditableComponentBuilder,
  TypePlaceholderComponentBuilder: TypePlaceholder,
  MissingComponentBuilder: index.MissingComponent,
  builtin: {
    $text: storage.$text,
    $backgroundColor: index.$backgroundColor,
    $image: $image,
    $video: $video,
    $buttons: index.$buttons,
    $stack: index.stack,
    $RootGrid: index.$RootGrid,
    $RootSections: index.$RootSections,
    $twoItems: index.TwoItems,
    $icon: index.icon,
    $richText: RichText,
    $richTextBlockElement: RichTextEmptyComponent,
    $richTextLineElement: RichTextEmptyComponent,
    $richTextPart: RichTextEmptyComponent,
    $richTextInlineWrapperElement: RichTextEmptyComponent,
    $vimeoPlayer: index.VimeoPlayer,
    $Playground: index.Playground,
    $Zone: index.$Zone
  }
};

var RendererEditor = index.buildRenderer(builders);

function createResourcesStore() {
  var store = new Map();
  var subscribers = [];
  var isBatching = false;

  function notify() {
    subscribers.forEach(function (subscriber) {
      subscriber();
    });
  }

  var resourcesStore = {
    get: function get(id, type) {
      var _store$get;

      return (_store$get = store.get(type)) === null || _store$get === void 0 ? void 0 : _store$get.get(id);
    },
    values: function values() {
      return Array.from(store.values()).flatMap(function (values) {
        return Array.from(values.values());
      });
    },
    set: function set(id, entry) {
      var resourcesForType = store.get(entry.type);

      if (!resourcesForType) {
        store.set(entry.type, new Map([[id, entry]]));
      } else {
        resourcesForType.set(id, entry);
        store.set(entry.type, resourcesForType);
      }

      if (!isBatching) {
        notify();
      }
    },
    subscribe: function subscribe(subscriber) {
      subscribers.push(subscriber);
      return function () {
        subscribers.splice(subscribers.indexOf(subscriber), 1);
      };
    },
    batch: function batch(callback) {
      isBatching = true;
      callback();
      isBatching = false;
      notify();
    },
    has: function has(id, type) {
      var resourcesForType = store.get(type);

      if (!resourcesForType) {
        return false;
      }

      return resourcesForType.has(id);
    }
  };
  return resourcesStore;
}

var resourcesStoreInstance = createResourcesStore();

function useResourcesStore() {
  var _useForceRerender = index.useForceRerender(),
      forceRerender = _useForceRerender.forceRerender;

  React.useEffect(function () {
    var unsubscribe = resourcesStoreInstance.subscribe(function () {
      forceRerender();
    });
    return function () {
      unsubscribe();
    };
  }, []);
  return resourcesStoreInstance;
}

var __jsx = React__default["default"].createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { index._defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var EditorChildWindow = function EditorChildWindow() {
  var _window$parent$editor = window.parent.editorWindowAPI,
      compilationOutput = _window$parent$editor.compilationOutput,
      editorContext = _window$parent$editor.editorContext,
      config = _window$parent$editor.config;

  var _useForceRerender = index.useForceRerender(),
      forceRerender = _useForceRerender.forceRerender;

  var resourcesStore = useResourcesStore();

  var _useState = React.useState(false),
      enabled = _useState[0],
      setEnabled = _useState[1];

  var _useState2 = React.useState(false),
      isInitialResourcesSyncDone = _useState2[0],
      setIsInitialResourcesSyncDone = _useState2[1];

  var apiStorage = React.useRef(storage.createApiStorage({
    accessToken: editorContext.accessToken
  })).current;
  var shopstoryClient = React.useRef(new InternalShopstoryClient(editorContext, resourcesStore, apiStorage)).current;

  var _useState3 = React.useState(_objectSpread(_objectSpread({}, compilationOutput.meta), {}, {
    resources: resourcesStore.values()
  })),
      meta = _useState3[0],
      setMeta = _useState3[1];

  React.useEffect(function () {
    if (window.self === window.top) {
      throw new Error("No host");
    } else {
      setEnabled(true);
    }
  }, []);
  React.useEffect(function () {
    window.parent.editorWindowAPI.onUpdate = function () {
      // Force re-render when child gets info from parent that data changed
      forceRerender();
    };
  });
  React.useEffect(function () {
    var unsubscribe = resourcesStore.subscribe(function () {
      window.parent.postMessage({
        type: "@shopstory/resourceStore/change",
        payload: {
          resources: resourcesStore.values()
        }
      }, "*");
    });
    return function () {
      unsubscribe();
    };
  }, []);
  storage.useEditorGlobalKeyboardShortcuts(editorContext);
  var shouldNotRender = !enabled || !compilationOutput || !editorContext || !isInitialResourcesSyncDone;
  var rootNode = React.useRef(null);
  React.useEffect(function () {
    if (shouldNotRender) {
      return;
    }

    if (rootNode.current && editorContext.isEditing) {
      var listener = function listener(e) {
        e.preventDefault();
      };

      rootNode.current.addEventListener("click", listener);
      return function () {
        var _rootNode$current;

        (_rootNode$current = rootNode.current) === null || _rootNode$current === void 0 ? void 0 : _rootNode$current.removeEventListener("click", listener);
      };
    }
  }, [enabled, editorContext.isEditing]);
  React.useEffect(function () {
    var _editorContext$contex;

    var shouldSyncResources = isAnyPendingResource(config, resourcesStore, editorContext);

    if (!shouldSyncResources) {
      // Enable first render if on initial sync there are no resources to sync
      if (!isInitialResourcesSyncDone) {
        setIsInitialResourcesSyncDone(true);
      }

      return;
    }

    shopstoryClient.add(config, {
      mode: (_editorContext$contex = editorContext.contextParams.mode) !== null && _editorContext$contex !== void 0 ? _editorContext$contex : "content"
    });

    function fetchResources() {
      return _fetchResources.apply(this, arguments);
    }

    function _fetchResources() {
      _fetchResources = index._asyncToGenerator( /*#__PURE__*/index.regenerator.mark(function _callee() {
        var _meta;

        return index.regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return shopstoryClient.build();

              case 3:
                _meta = _context.sent;
                setMeta(function (currentMeta) {
                  // We HAVE TO merge new meta result with current meta to preserve definitions of components
                  return _objectSpread(_objectSpread({}, mergeCompilationMeta(currentMeta, _meta)), {}, {
                    resources: _meta.resources
                  });
                }); // We want first render to be with all resources fetched to prevent massive layout shift as a first thing user sees

                if (!isInitialResourcesSyncDone) {
                  setIsInitialResourcesSyncDone(true);
                }

                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                console.error(_context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 8]]);
      }));
      return _fetchResources.apply(this, arguments);
    }

    fetchResources();
  }, [config]);

  if (shouldNotRender) {
    return __jsx("div", null, "Loading data...");
  }

  var srcWithResources = _objectSpread(_objectSpread({}, compilationOutput), {}, {
    meta: _objectSpread(_objectSpread({}, mergeCompilationMeta(compilationOutput.meta, meta)), {}, {
      resources: meta.resources
    })
  });

  return (// ShopstoryMetadataProvider must be defined in case of nested <Shopstory /> components are used!
    __jsx(index.ShopstoryMetadataProvider, {
      meta: srcWithResources.meta
    }, __jsx(index.EditorContext.Provider, {
      value: editorContext
    }, __jsx(storage.EventDispatcherProvider, {
      target: window.parent
    }, __jsx("div", {
      ref: rootNode,
      onClick: function onClick() {
        editorContext.setFocussedField([]);
      }
    }, editorContext.isEditing && __jsx("div", {
      style: {
        minHeight: "100vh"
      }
    }, __jsx("style", {
      dangerouslySetInnerHTML: {
        __html: globalEditorRendererStyles
      }
    }), __jsx(RendererEditor, {
      src: srcWithResources
    })), !editorContext.isEditing && __jsx(index.RendererClient, {
      src: srcWithResources
    })))))
  );
};
var globalEditorRendererStyles = "\n    /*\n        We don't use Tina native blocksmenu and they make page higher than document height (on the last section). So this is quick fix\n    */\n    [class^=BlocksMenu] {\n        display: none !important;\n    }\n    \n    body {\n        margin: 0;\n        padding: 0;\n        overflow-x: hidden;\n    }\n      \n  :root {\n    --tina-color-primary-light: #2296fe;\n    --tina-color-primary: #2296fe;\n    --tina-color-primary-dark: #0574e4;\n    --tina-color-error-light: #eb6337;\n    --tina-color-error: #ec4815;\n    --tina-color-error-dark: #dc4419;\n    --tina-color-warning-light: #f5e06e;\n    --tina-color-warning: #e9d050;\n    --tina-color-warning-dark: #d3ba38;\n    --tina-color-success-light: #57c355;\n    --tina-color-success: #3cad3a;\n    --tina-color-success-dark: #249a21;\n    --tina-color-grey-0: #ffffff;\n    --tina-color-grey-1: #f6f6f9;\n    --tina-color-grey-2: #edecf3;\n    --tina-color-grey-3: #e1ddec;\n    --tina-color-grey-4: #b2adbe;\n    --tina-color-grey-5: #918c9e;\n    --tina-color-grey-6: #716c7f;\n    --tina-color-grey-7: #565165;\n    --tina-color-grey-8: #433e52;\n    --tina-color-grey-9: #363145;\n    --tina-color-grey-10: #282828;\n    --tina-radius-small: 5px;\n    --tina-radius-big: 24px;\n    --tina-padding-small: 12px;\n    --tina-padding-big: 20px;\n    --tina-font-size-0: 12px;\n    --tina-font-size-1: 13px;\n    --tina-font-size-2: 15px;\n    --tina-font-size-3: 16px;\n    --tina-font-size-4: 18px;\n    --tina-font-size-5: 20px;\n    --tina-font-size-6: 22px;\n    --tina-font-size-7: 26px;\n    --tina-font-size-8: 32px;\n    --tina-font-family: 'Inter', sans-serif;\n    --tina-font-weight-regular: 400;\n    --tina-font-weight-bold: 600;\n    --tina-shadow-big: 0px 2px 3px rgba(0, 0, 0, 0.05),\n      0 4px 12px rgba(0, 0, 0, 0.1);\n    --tina-shadow-small: 0px 2px 3px rgba(0, 0, 0, 0.12);\n    --tina-timing-short: 85ms;\n    --tina-timing-medium: 150ms;\n    --tina-timing-long: 250ms;\n    --tina-z-index-0: 500;\n    --tina-z-index-1: 1000;\n    --tina-z-index-2: 1500;\n    --tina-z-index-3: 2000;\n    --tina-z-index-4: 2500;\n    --tina-z-index-5: 3000;\n    --tina-sidebar-width: 340px;\n    --tina-sidebar-header-height: 60px;\n    --tina-toolbar-height: 62px;\n    \n    \n  }\n  \n  .Shopstory__ReactModal__Overlay {\n    width: 100vw;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    \n  }\n  \n  .Shopstory__ReactModal__Overlay::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      opacity: 0.2;\n      z-index: -1;\n      /* background-color: black; */\n  }\n  \n  .Shopstory__ReactModal__Overlay.background-shade::before {\n      background-color: black;\n  }\n  \n  .Shopstory__ReactModal__Content::focus {\n    border: none;\n    outline: none;\n  }\n  \n  \n  .Shopstory__ReactModal__Content__Left {\n    height: 100vh;\n    width: 70vw;\n    \n    transition: all 350ms cubic-bezier(0.16, 1, 0.3, 1);\n    transform: translateX(-100%);\n  }\n  \n  \n  .Shopstory__ReactModal__Content__Left::focus {\n    border: none;\n    outline: none;\n  }\n  \n  .Shopstory__ReactModal__Content__Left.Shopstory__ReactModal__Content__Left--after-open {\n      transform: none;\n  }\n  \n  .Shopstory__ReactModal__Content__Left.Shopstory__ReactModal__Content__Left--before-close{\n      transform: translateX(-100%);\n  }\n";

exports.EditorChildWindow = EditorChildWindow;
